import React from "react";
import IsNullOrEmpty from "../../models/helpers/isNullOrEmpty.ts";

const FormTextArea = ({
    entity,
    fieldName,
    handleInputChange,
    label,
    rows,
    disabled = false,
    errors
}: {
    entity: any,
    fieldName: string,
    handleInputChange: any,
    label?: string,
    rows?: number,
    disabled?: boolean,
    errors?: any
}) => {
    if (disabled && IsNullOrEmpty(entity[fieldName]))
        return;

    if (disabled)
        return (
            <div className="form-floating mb-3">
                <h6>{label ?? fieldName}</h6>
                <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{entity[fieldName]}</pre>
            </div>
        );

    return (
        <div className="form-floating mb-3">
            <textarea
                className={`form-control ${errors?.[fieldName] ? 'is-invalid' : ''}`}
                id={fieldName}
                value={entity[fieldName] ?? ''}
                onChange={handleInputChange}
                style={{ height: `${rows || 6}em` }}
                readOnly={disabled}
            />
            <label htmlFor={fieldName}>{label ? label : fieldName}</label>
            {errors?.[fieldName] &&
                <div className="invalid-feedback">
                    {errors?.[fieldName]}
                </div>}
        </div>
    )
}

export default FormTextArea;